var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 28.8569,
    width: 24,
    height: 8,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 28.8569,
    width: 24,
    height: 8,
    transform: "rotate(90 117 28.8569)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 28.8569,
    width: 24,
    height: 8,
    transform: "rotate(90 210 28.8569)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 36.8569,
    width: 24,
    height: 8,
    transform: "rotate(-180 210 36.8569)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 124.857,
    width: 24,
    height: 8,
    transform: "rotate(-180 210 124.857)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 124.857,
    width: 24,
    height: 8,
    transform: "rotate(-90 202 124.857)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 124.857,
    width: 24,
    height: 8,
    transform: "rotate(-90 109 124.857)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 116.857,
    width: 24,
    height: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186 48.8569V64.0133H184.433C183.505 60.5167 182.475 58.0113 181.344 56.4971C180.213 54.9553 178.661 53.7301 176.688 52.8215C175.586 52.326 173.657 52.0782 170.901 52.0782H166.506V95.2758C166.506 98.1391 166.665 99.9287 166.984 100.645C167.333 101.36 167.985 101.994 168.943 102.544C169.929 103.067 171.263 103.329 172.946 103.329H174.904V104.857H144.009V103.329H145.967C147.679 103.329 149.057 103.04 150.101 102.462C150.855 102.076 151.45 101.415 151.885 100.479C152.204 99.8186 152.364 98.0841 152.364 95.2758V52.0782H148.099C144.125 52.0782 141.239 52.8766 139.44 54.4735C136.916 56.7035 135.321 59.8835 134.654 64.0133H133V48.8569H186Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 150.857,
    width: 304,
    height: 9.14286,
    fill: "#0056A4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.3bf6d33e51f1444d5f049d589ae7901e.svg";
export { ForwardRef as ReactComponent };